
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25 48.6l-.9-.9c-.2-.2-4.2-4.1-8.2-9.5-5.5-7.4-8.4-13.6-8.4-18.6C7.6 10 15.4 2.2 25 2.2S42.5 10 42.5 19.6c0 11.3-15.9 27.4-16.6 28.1l-.9.9zm0-43.9c-8.2 0-14.9 6.7-14.9 15 0 9.2 11.6 21.9 14.9 25.4 3.3-3.5 15-16.6 15-25.4 0-8.3-6.8-15-15-15z"}}),_c('path',{attrs:{"d":"M15.6 27.9c-2-2.3-3.1-5.2-3.1-8.3 0-2.9 1-5.8 2.9-8l1.9 1.6C15.8 15 15 17.3 15 19.6c0 2.4.9 4.8 2.5 6.6l-1.9 1.7zM34.4 27.9l-1.9-1.7c1.6-1.8 2.5-4.2 2.5-6.6 0-2.3-.8-4.6-2.3-6.4l1.9-1.6c1.9 2.2 2.9 5.1 2.9 8 0 3.1-1.1 6-3.1 8.3zM25 24c-2.4 0-4.4-2-4.4-4.4s2-4.4 4.4-4.4c2.4 0 4.4 2 4.4 4.4S27.4 24 25 24zm0-6.2c-1 0-1.9.8-1.9 1.9 0 1 .8 1.9 1.9 1.9 1 0 1.9-.8 1.9-1.9 0-1.1-.9-1.9-1.9-1.9z"}})])
          )
        }
      }
    